import React from 'react'
import {useEffect, useState} from 'react'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {
    Box,
    useBreakpointValue,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    Flex,
    Text
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {contentStyle} from './index.style'
import useCustomFetch from '../../hooks/useFetchContent'
const contentAssetIDs =
    'footer-account,footer-about,footer-contact-info,footer-support,footer-emailsignup-socialicons,footer-copy'

const Footer = () => {
    const {token} = useAccessToken()
    const {response: htmlString, loading, error} = useCustomFetch(token, contentAssetIDs, false)
    const [accordionAssets, setAccordionAssets] = useState([])
    const [staticAssets, setStaticAssets] = useState([])
    const isMobile = useBreakpointValue({base: true, md: false})

    useEffect(() => {
        if (!htmlString) return
        const parser = new DOMParser()
        const doc = parser.parseFromString(htmlString, 'text/html')
        const headers = doc.querySelectorAll('h3')

        // Parse sections for the Accordion
        const parsedAccordionAssets = Array.from(headers).map((header) => {
            const body = header.nextElementSibling?.outerHTML || ''
            return {
                title: header.textContent,
                body
            }
        })

        // Parse remaining divs that are not part of the Accordion
        const parsedStaticSections = Array.from(doc.body.children)
            .filter((child) => ['footer-emailsignup-socialicons', 'footer-copy'].includes(child.id))
            .map((div) => div.outerHTML)
        setAccordionAssets(parsedAccordionAssets)
        setStaticAssets(parsedStaticSections)
    }, [htmlString])

    useEffect(() => {
        window.semaphore = window.semaphore || []
        window.ketch = function () {
            window.semaphore.push(arguments)
        }

        // Create and append the script
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = 'https://global.ketchcdn.com/web/v3/config/cavenders/website_smart_tag/boot.js'
        script.defer = true
        script.async = true
        document.getElementsByTagName('head')[0].appendChild(script)

        // Setup MutationObserver to watch for changes in the DOM
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.addedNodes.length) {
                    const anchor = document.querySelector(
                        'a[onclick="semaphore.push([\'showPreferences\'])"]'
                    )
                    if (anchor) {
                        anchor.removeAttribute('onclick')
                        anchor.addEventListener('click', (event) => {
                            event.preventDefault()
                            window.semaphore.push(['showPreferences'])
                        })
                        observer.disconnect() // Stop observing once the anchor is found and modified
                    }
                }
            })
        })

        // Start observing
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })

        // Cleanup function
        return () => {
            observer.disconnect()
            document.getElementsByTagName('head')[0].removeChild(script)
        }
    }, []) // Empty dependency array ensures this effect runs only once

    return (
        <Box sx={contentStyle}>
            {isMobile ? (
                <div className="footer-container-mobile">
                    <Accordion allowToggle>
                        {accordionAssets.map((section, idx) => (
                            <AccordionItem
                                className="accordion-item"
                                key={`${section.title}-${idx}`}
                            >
                                {({isExpanded}) => (
                                    <>
                                        <h3 className="accordion-header">
                                            <AccordionButton
                                                className="accordion-header-text"
                                                aria-expanded={isExpanded}
                                                aria-controls={`${section.title}-${idx}`}
                                            >
                                                <Flex flex="1" textAlign="left" alignItems="center">
                                                    {section.title}
                                                </Flex>
                                                <Text className="accordion-header-btn">
                                                    {isExpanded ? '-' : '+'}
                                                </Text>
                                            </AccordionButton>
                                        </h3>
                                        <AccordionPanel
                                            id={`${section.title}-${idx}`}
                                            className="accordion-panel-content"
                                            role="region"
                                        >
                                            <div
                                                dangerouslySetInnerHTML={{__html: section.body}}
                                            ></div>
                                        </AccordionPanel>
                                    </>
                                )}
                            </AccordionItem>
                        ))}
                    </Accordion>
                    {staticAssets.map((staticContent, idx) => (
                        <div
                            key={`static-${idx}`}
                            className="static-content"
                            dangerouslySetInnerHTML={{__html: staticContent}}
                        ></div>
                    ))}
                </div>
            ) : (
                <div
                    className="footer-container"
                    dangerouslySetInnerHTML={{__html: htmlString}}
                ></div>
            )}
        </Box>
    )
}

export default Footer
